__webpack_require__.p = "/snv/";